import '@formatjs/intl-relativetimeformat/polyfill';
import '@formatjs/intl-relativetimeformat/dist/locale-data/en';
import '@formatjs/intl-relativetimeformat/dist/locale-data/he';
import '@formatjs/intl-relativetimeformat/dist/locale-data/fr';
import '@formatjs/intl-relativetimeformat/dist/locale-data/de';
import '@formatjs/intl-relativetimeformat/dist/locale-data/it';
import '@formatjs/intl-relativetimeformat/dist/locale-data/ru';
import '@formatjs/intl-relativetimeformat/dist/locale-data/pl';
import '@formatjs/intl-relativetimeformat/dist/locale-data/es';
import '@formatjs/intl-relativetimeformat/dist/locale-data/ko';
import '@formatjs/intl-relativetimeformat/dist/locale-data/id';
import '@formatjs/intl-relativetimeformat/dist/locale-data/nl';
import '@formatjs/intl-relativetimeformat/dist/locale-data/cs';
import '@formatjs/intl-relativetimeformat/dist/locale-data/pt';
import '@formatjs/intl-relativetimeformat/dist/locale-data/uk';
import '@formatjs/intl-relativetimeformat/dist/locale-data/zh';

import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/dist/locale-data/en';
import '@formatjs/intl-pluralrules/dist/locale-data/he';
import '@formatjs/intl-pluralrules/dist/locale-data/fr';
import '@formatjs/intl-pluralrules/dist/locale-data/de';
import '@formatjs/intl-pluralrules/dist/locale-data/it';
import '@formatjs/intl-pluralrules/dist/locale-data/ru';
import '@formatjs/intl-pluralrules/dist/locale-data/pl';
import '@formatjs/intl-pluralrules/dist/locale-data/es';
import '@formatjs/intl-pluralrules/dist/locale-data/ko';
import '@formatjs/intl-pluralrules/dist/locale-data/id';
import '@formatjs/intl-pluralrules/dist/locale-data/nl';
import '@formatjs/intl-pluralrules/dist/locale-data/cs';
import '@formatjs/intl-pluralrules/dist/locale-data/pt';
import '@formatjs/intl-pluralrules/dist/locale-data/uk';
import '@formatjs/intl-pluralrules/dist/locale-data/zh';

import LocalizedDayjs from 'common/localized_dayjs';

const configureLocales = function(locale) {
  LocalizedDayjs.locale(locale);
};

export { configureLocales };
